import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=41059485&scoped=true&"
import script from "./NoticeBar.vue?vue&type=script&lang=js&"
export * from "./NoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=41059485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41059485",
  null
  
)

export default component.exports